<div id="photo-gallery" class="watermark">
    <div class="container-fluid px-lg-5">
        <div class="row">
            <div class="col-12">
                <h2 class="inner-title">Photo</h2>

                <div class="row mt-3">
                    <div class="col-12 col-md-6 col-lg-4 col-xl-4 mb-4" *ngFor="let image of images;let i = index">
                        <div class="image" id="{{image.$key}}"  (click)="openGalleryList(image.$key,image.caption)">
                            <img [src]="image.imgUrl[0]" [alt]="image.caption" class="img-fluid photo">
                            <div class="overlay">
                                {{image.caption}}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>